// Last casino round detail fetched via getDetailResults(type, mid).
//
// Admin ke 48 result widgets (pages/diamondCasinoAllGames/resultui/*) sab click
// par pehle getDetailResults() call karte hain aur phir shared ResultModalLayout
// kholte hain — har widget detail ko alag naam ki state me rakhta hai. Ye store
// wahi response yaad rakhta hai taaki ResultModalLayout bina 48 files badle user
// site / original admin jaisa result (cards, trophy, winner box) dikha sake.
let current = null // { type, mid, response }
const listeners = new Set()

export function setLastCasinoDetail(type, mid, response) {
  current = { type: String(type || '').toLowerCase(), mid: String(mid || ''), response }
  listeners.forEach((l) => l())
}

export const getLastCasinoDetail = () => current

export function subscribeLastCasinoDetail(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
